<template>
  <div class="editbox">
    <infoSlider :style="{zIndex: 999}" :show="add" @close="$emit('close')"  :label="'新增合作代理'" defaultClass="123" :width="481" :icon="'partner'">
      <div class="editCube">
        <section class="top" label="註記">
            <textarea v-model="editItem.remark"></textarea>
        </section>
        <section :style="{order:-6}">
          <div class="required-hint">* 為必填欄位</div>
          <div class="field field-edit">
            <div>類別</div>
              <Select1 :defaultValue="editItem.tag" @input="editItem.tag=$event" :width="'160px'">
              <option :value="null">類別</option>
              <option v-for="(country, i) in partnerCategories" :key="`country-${i}`" :value="country.name">{{country.name}}</option>
            </Select1>
          </div>
          <div class="field field-edit">
            <div>名稱 <span class="required">*</span></div>
            <div class="input-wrap">
              <input type="text" :style="{width: '275px', borderColor: errors.name ? '#FF7373' : ''}" v-model="editItem.name" @input="errors.name=false">
              <span class="error-msg" v-if="errors.name">請填寫名稱</span>
            </div>
          </div>
          <div class="field field-edit">
            <div>電話 <span class="required">*</span></div>
            <div class="input-wrap">
              <input type="tel" :style="{width: '200px', borderColor: errors.tel ? '#FF7373' : ''}" v-model="editItem.tel" @input="errors.tel=false">
              <span class="error-msg" v-if="errors.tel">請填寫電話</span>
            </div>
          </div>
          <div class="field field-edit">
            <div>統編 <span class="required">*</span></div>
            <div class="input-wrap">
              <input type="text" :style="{width: '145px', borderColor: errors.taxID ? '#FF7373' : ''}" v-model="editItem.taxID" @input="errors.taxID=false">
              <span class="error-msg" v-if="errors.taxID">請填寫統編</span>
            </div>
          </div>
          <div class="field field-edit">
            <div>縣市</div>
            <Select1 :width="'185px'" :defaultValue="editItem.country" @input="editItem.country=$event">
              <option :value="null">縣市</option>
              <option v-for="(country, i) in countries" :key="`country-${i}`" :value="country">{{country}}</option>
            </Select1>
          </div>
          <div class="field">
            <div>地址</div>
            <textarea v-model="editItem.address" :style="{width: '275px',minHeight: '120px'}"></textarea>
          </div>
          <div class="field field-edit">
            <div>窗口</div>
            <input type="text" :style="{width: '200px'}" v-model="editItem.head">
          </div>
          <div class="field field-edit">
            <div>電話</div>
            <input type="tel"  :style="{width: '200px'}" v-model="editItem.headTel">
          </div>
        </section>
        <BtnsS :style="{marginTop: '15px', flexDirection:'row', flexWrap:'nowrap', display:'flex'}" @cancel="$emit('close')" @save="save"/>
      </div>
    </infoSlider>
  </div>
</template>

<script>
import infoSlider from '../../components/infoSlider_v2.vue'
import { putapi } from '../../store/fetch'
export default {
  props: ['add', 'countries', 'partnerCategories'],
  components: {
    infoSlider
  },
  data () {
    return {
      edit: null,
      errors: {},
      editItem: {
        contract: false,
        tag: null,
        type: null,
        address: null,
        name: null,
        taxID: null,
        remark: null,
        country: null,
        head: null,
        headTel: null,
        tel: null
      }
    }
  },
  methods: {
    async save () {
      this.errors = {}
      if (!this.editItem.name) this.errors.name = true
      if (!this.editItem.tel) this.errors.tel = true
      if (!this.editItem.taxID) this.errors.taxID = true
      if (Object.keys(this.errors).length) return
      const params = { ...this.editItem }
      params.visitDate = this.moment(params.visitDate).startOf('day').toISOString()
      const ret = await putapi('partners', params)
      if (ret) {
        this.$emit('updateItem', ret)
        this.errors = {}
        this.editItem = {
          contract: false,
          tag: null,
          address: null,
          name: null,
          taxID: null,
          remark: null,
          country: null,
          head: null,
          headTel: null,
          tel: null
        }
      }
    }
  }
}
</script>
<style lang="scss">
.editbtn1 {
  &.absbtn {
    width: 32px;
    height: 32px;
    &::before {
      background-color: var(--color-pri);
    }
  }
}
</style>
<style lang="scss" scoped>
*, *::before, *::after {
  box-sizing: border-box;
}
.orderTypes {
  display: flex;
  align-items: center;
}
.orderTypes > input {
  appearance: none;width: 54px;
  height: 39px;
  background: #FFFFFF;
  border: 1.5px solid var(--c);
  border-radius: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);
  }
  &.自取 {
    border: 1.5px solid var(--自取);
    color:  var(--自取);
    &:checked {
      background-color: var(--自取);
    }
  }
  &.宅配 {
    border: 1.5px solid var(--宅配);
    color:  var(--宅配);
    &:checked {
      background-color: var(--宅配);
    }
  }
  &:checked {
    color: #FFFFFF;
  }
}
.vip, .vvip, .supervip, .none {
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: bottom;
  background-size: contain;
  appearance: none;
  mask-repeat: no-repeat;
  mask-position: center;
  mask-size: contain;
  background-color: #CACACA;
  &:checked {
    mask-image: none;
    background-color: transparent;
  }
}
.vip {
  mask-image: url(/vip.svg);
}
.vip:checked {
  background-image: url(/vip.svg);
}
.vvip {
  mask-image: url(/vvip.svg);
}
.vvip:checked {
  background-image: url(/vvip.svg);
}
.none {
  mask-image: url(/svg/btn/close.svg);
  mask-size: 20px;
}
.supervip {
  mask-image: url(/supervip.svg);
}
.supervip:checked {
  background-image: url(/supervip.svg);
}
.hr2 {
  margin: .5em 0;
  border-block: 3px solid #FFFFFF;
  border-inline: 8px solid var(--color-pri);
  background-color: var(--color-pri);
  height: 8px;
}
.required {
  color: #FF7373;
}
.required-hint {
  font-size: 13px;
  color: #FF7373;
  text-align: end;
}
.input-wrap {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.error-msg {
  font-size: 12px;
  color: #FF7373;
  line-height: 1.4;
}
.editbox {
  position: fixed;
  left: auto;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
}
label {
  position: relative;
  z-index: 1;
}
.removebtn {
  margin-left: auto;
}
.absbtn {
  position: absolute;
  top: 20px;
  right: 18px;
}
.agency-box {
  display: flex;
  align-items: center;
  height: 40px;
  padding-inline: .75em;
  border: 1px solid #CACACA;
  border-radius: 3px;
  font-size: 18px;
  button {
    background-color: #CACACA;
    width: 23px;
    height: 30px;
    mask-image: url(/svg/btn/close.svg);
    mask-size: 15px;
    mask-repeat: no-repeat;
    mask-position: center;
    border: none;
    outline: 1px solid #CACACA;
    box-sizing: content-box;
    padding: 0;

  }
}
.internalremark {
  display: flex;
  flex-direction: column;
  gap: 6px;
  &>:nth-child(1) {
    font-weight: 400;
    font-size: 16px;
    line-height: 180%;
    color: #FFFFFF;
    width: 125px;
    height: 30px;
    background: #FF7373;
    border-radius: 50px;
  }
  &>:nth-child(2) {
    text-align: start;
    font-weight: 400;
    font-size: 15px;
    line-height: 180%;
    color: #FF7373;
  }
}
.field-foot {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 16px;
  line-height: 23px;
  color: #999999;
  letter-spacing: 0;
}
hr {
  height: 1px;
  border: none;
  background-color:#CACACA;
  width: 100%;
  margin: 0;
}
.flexrow {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.field {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 70px 1fr;
  gap: 28px;
  &.field-edit {
    line-height: 35px;
    position: relative;
  }
  &>:nth-child(1) {
    text-align: end;
    position: relative;
    z-index: 1;
  }
  label {
    position: relative;
    z-index: 1;
  }
  input[type=tel], input[type=text], textarea {
    position: relative;
    z-index: 1;
    width: 220px;
    height: 40px;
    border: 1px solid #CACACA;
    border-radius: 3px;
    padding-inline: .75em;
    box-sizing: border-box;
    font-size: 18px;
    color: #5E5E5E;
  }
  textarea {
    padding-block: .5em;
  }
  &>:nth-child(2) {
    text-align: start;
    z-index: 1;
    position: relative;
    * {
      position: relative;
      z-index: 1;
    }
    .ul {
      position: absolute;
      right: 0;
      width: 350px;
      background-color: #FFFFFF;
      max-height: 230px;
      overflow-y: auto;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      z-index: 99;
      .li {
        z-index: 99;
        position: relative;
        padding-block: 7.25px;
        padding-inline: .75em;
        min-height: 55px;
        display: flex;
        align-items: flex-start;
        gap: 10px;
        line-height: 40px;
        &:hover {
          background-color: #CACACA;
        }
      }
    }
  }
}
section {
  position: relative;
  z-index: 1;
  flex: 1;
  border: 1px solid #B9B9B9;
  border-radius: 10px;
  padding: 20px 20px 13px 23px;
  width: 100%;
  font-weight: 400;
  font-size: 20px;
  line-height: 29px;
  letter-spacing: 0.1em;
  color: #5E5E5E;
  display: flex;
  flex-direction: column;
  gap: 11px;
  height: fit-content;
}
section.top {
  padding: 0;
  z-index: 1;
  flex: 1;
  &::before {
    content: attr(label);
    display: inline;
    width: 100%;
    height: 45px;
    background-color: var(--color-pri);
    color: #FFFFFF;
    text-align: start;
    border-radius: 10px 10px 0 0;
    display: flex;
    align-items: center;
    padding-inline: 28px;
  }
  &>div, &>textarea{
    border: none;
    height: fit-content;
    padding: 21px 13px 21px 28px;
    text-align: start;
    font-weight: 400;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.1em;
    color: #787878;
  }
  textarea {
    min-height: 200px;
  }
}
section.orders>div:nth-child(1) {
  gap: 15px;
  display: flex;
  flex-direction: column;
}
.editCube {
  flex: 1;
  padding: 31px 20px 30px 30px;
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
  margin-right: 8px;
  height: 100%;
  overflow-y: auto;
  align-content: flex-start;
  gap: 19px;
}
</style>
